import React from "react";
import {
  Home,
  DollarSign,
  Search,
  Users,
  Building2,
  Handshake,
  BarChart3,
  MapPin,
  TrendingUp,
} from "lucide-react";
import "./OrbitingIcons.scss";

const DEFAULT_ICONS = [
  { Icon: Home, radius: 100, duration: 30, startAngle: 0, size: 26 },
  { Icon: DollarSign, radius: 100, duration: 30, startAngle: 180, size: 22 },
  { Icon: Search, radius: 160, duration: 26, startAngle: 0, size: 24 },
  { Icon: Users, radius: 160, duration: 26, startAngle: 120, size: 24 },
  { Icon: Building2, radius: 160, duration: 26, startAngle: 240, size: 26 },
  { Icon: Handshake, radius: 220, duration: 22, startAngle: 60, size: 28 },
  { Icon: BarChart3, radius: 220, duration: 22, startAngle: 240, size: 24 },
  { Icon: MapPin, radius: 280, duration: 28, startAngle: 30, size: 22 },
  { Icon: TrendingUp, radius: 280, duration: 28, startAngle: 210, size: 26 },
];

const RIPPLE_COUNT = 8;
const RIPPLE_MAIN_SIZE = 80;
const RIPPLE_STEP = 70;
const RIPPLE_MAIN_OPACITY = 0.35;

const OrbitingIcons = ({ icons = DEFAULT_ICONS, className = "" }) => {
  return (
    <div className={`orbiting-icons ${className}`.trim()} aria-hidden="true">
      {Array.from({ length: RIPPLE_COUNT }, (_, i) => {
        const size = RIPPLE_MAIN_SIZE + i * RIPPLE_STEP;
        const opacity = RIPPLE_MAIN_OPACITY - i * 0.03;
        const borderOpacity = (8 + i * 4) / 100;
        const isLast = i === RIPPLE_COUNT - 1;
        return (
          <span
            key={`ripple-${i}`}
            className="orbiting-icons__ripple"
            style={{
              width: `${size}px`,
              height: `${size}px`,
              marginTop: `${-size / 2}px`,
              marginLeft: `${-size / 2}px`,
              opacity,
              borderStyle: isLast ? "dashed" : "solid",
              borderColor: `rgba(255, 255, 255, ${borderOpacity})`,
              animationDelay: `${i * 0.06}s`,
            }}
          />
        );
      })}
      {icons.map(({ Icon, radius, duration, startAngle, size }, idx) => (
        <span
          key={`icon-${idx}`}
          className="orbiting-icons__icon"
          style={{
            "--orbit-radius": `${radius}px`,
            "--orbit-duration": `${duration}s`,
            "--orbit-start-angle": startAngle,
          }}
        >
          <Icon size={size} strokeWidth={1.6} />
        </span>
      ))}
    </div>
  );
};

export default OrbitingIcons;
